module.exports = __webpack_public_path__ + "img/L1060784.5b64193e.jpg";